// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_92-4";
export var collapsed = "_92-1";
export var headerBar = "_92-0";
export var leftHeaderContent = "_92-3";
export var subjectContainer = "_92-2";